module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        This action requires authentication through <b>Mazda Portal</b> <br /><br />\r\n\r\n        <b>Please save any changes before proceeding</b><br /><br />\r\n\r\n        You will be redirected to Mazda Portal for authentication. <br />\r\n        Please use your Mazda account to login and you will be automatically redirected back to this page\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/templates/vehicle/mazdaAuthConsentTemplate.html
// module id = 1952
// module chunks = 0